import * as React from "react";
import { DetailActionProps, getNextPage } from "../detail-actions-props";

import Button from "@material-ui/core/Button";
import ApproveIcon from "@material-ui/icons/Check";
import LoadingIcon from "@material-ui/icons/Timelapse";

import { approve as approveRelease } from "../../../../../sdk/release";
import { useHistory, useLocation } from "react-router";
import { handleReleaseApproved } from "../../../../../utils/rudderstack/events";

export const AcceptRelease: React.FC<DetailActionProps> = (props) => {
  const { data } = props;
  const history = useHistory();
  const location = useLocation<{from?: string}>();

  const [loading, setLoading] = React.useState(false);

  const handleClick = async () => {
    setLoading(true);
    
    await Promise.all(
      data.map(async ({ release, assets, tracks }) => {
        await approveRelease(
          release.id,
          release.UPCEAN as string,
          `${release.id}.json`,
          !!assets?.some((a) => a.category === "video"),
          release.cover.url,
          release.title
        );
        await handleReleaseApproved({ release, tracks});
      })
    );
    props.onAction(data.map(({ release }) => release.id));
    setLoading(false);

    history.push(getNextPage(location.state?.from), location.state);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      endIcon={loading ? <LoadingIcon /> : <ApproveIcon />}
      onClick={handleClick}
    >
      Approve
    </Button>
  );
};
